import { useCustomCategories } from '@/hooks/useCustomCategories';

/**
 * Mounts useCustomCategories() once at the app shell so the global
 * customCategoryMap (in src/lib/categories.ts) is populated for every
 * authenticated route. This ensures getCategoryLabel/getCategoryEmoji
 * resolve custom-category UUIDs anywhere in the app.
 */
export function CustomCategoriesLoader() {
  useCustomCategories();
  return null;
}
